import React, { createContext, useContext, forwardRef, useState, useCallback } from 'react';
import { Map } from 'react-leaflet';

const DeviceMapContext = createContext(null);

export const DeviceMapProvider = forwardRef(function DeviceMapProvider({ children, ...rest }, ref) {
  const [map, setMap] = useState(null);
  const register = useCallback(
    (element) => {
      if (element) {
        setMap(element.leafletElement);
      }

      if (ref) {
        if (typeof ref === 'function') {
          ref(element);
        } else {
          ref.current = element;
        }
      }
    },
    [ref]
  );

  return (
    <DeviceMapContext.Provider value={map}>
      <Map ref={register} {...rest}>
        {children}
      </Map>
    </DeviceMapContext.Provider>
  );
});

export function useDeviceMap() {
  return useContext(DeviceMapContext);
}
